import { NAV_KEYS } from "@/navigation/keys";

/** Params that may live on the OS window but must not appear in shareable URLs. */
export const TRANSIENT_URL_PARAM_KEYS: readonly string[] = [
  NAV_KEYS.focusSeq,
  NAV_KEYS.asUserId,
  "navSeq",
  "shell",
  "workflow",
  "from",
];

export function stripTransientUrlParams(
  params: Record<string, string>,
): Record<string, string> {
  const out = { ...params };
  for (const key of TRANSIENT_URL_PARAM_KEYS) {
    delete out[key];
  }
  return out;
}
